<template>
  <div>
    <div v-if="getAmount >= 0.05 && isSpecial == false">
      <div v-if="userData.length > 0 && dataFound" class="page-content">
        <div style="text-align:center">
          <h2 class="headline mb-4">Approved User Details</h2>
        </div>

        <div
          style="margin-bottom:20px;"
          v-if="userData.length > 0"
          class="container"
        >
          <div
            class="p-1 card"
            style="border-radius:10px;border-left:#2C80FF 4px solid;border-right:#2C80FF 4px solid"
          >
            <!-- <div style="border:1px black" class="input-group py-1">
              <input
                type="search"
                v-model="name"
                style="border-right:0"
                placeholder="Search by Email address or Name"
                aria-describedby="button-addon1"
                class="form-control bg-light"
              >
            <div class="input-group-append">
              <button
                type="submit"
                style="border-radius:0px 3px 3px 0px;border-left:0px "
                class="border bg-light px-2 py-0 text-primary btn-link"
              >
                <em class="fa fa-search"></em>
              </button>
            </div>
          </div> -->

            <div class="">
              <div v-if="getUserData.length > 0">
                <center>
                  <vue-good-table
                   
                    :sort-options="{
                      enabled: false,
                    }"
                    :search-options="{
                      enabled: true,
                      externalQuery: search,
                      skipDiacritics: true,
                      searchFn: searchData,
                      placeholder:
                        'Search by Email address or Name',
                    }"
                    style="width:auto;z-index:0;border-radius:10px;"
                    :columns="columns"
                    :rows="getUserData"
                    :pagination-options="{
                      enabled: true,
                      mode: 'records',
                      perPage: 5,
                      position: 'bottom',
                      perPageDropdown: [3, 7, 10,15,20],
                      dropdownAllowAll: false,
                      setCurrentPage: 1,
                      nextLabel: 'Next',
                      prevLabel: 'Prev',
                      rowsPerPageLabel: 'Rows per page',

                      pageLabel: 'page', // for 'pages' mode
                      allLabel: 'All',
                    }"
                  >
                    <template slot="table-row" slot-scope="props">
                      <span v-if="props.column.field == 'user'">
                        <p class="font-bold mb-0">{{ props.row.fullName }}</p>
                        <p style="font-size:13px;" class=" mb-0 mt-0 pt-0">
                          {{ props.row.email }}
                        </p>

                        <!-- <span
                        class="dt-status-sm badge badge-sq badge-outline badge-success badge-md"
                        >A</span
                      > -->
                      </span>
                      <span v-if="props.column.field == 'status'">
                        <span
                          class=" badge badge-outline badge-success badge-md"
                          >Approved</span
                        >
                        <!-- <span
                        class="dt-status-sm badge badge-sq badge-outline badge-success badge-md"
                        >A</span
                      > -->
                      </span>
                      <span v-if="props.column.field == 'viewDetails'">
                        <span
                          @click="
                            $router.push({
                              name: 'userDataParty',
                              params: { userAddress: props.row.userAddress },
                            })
                          "
                        >
                          <span
                            style="margin-left:0"
                            href="#"
                            class="btn btn-light-alt btn-xs btn-icon"
                          >
                            <em class="ti ti-eye"></em> View Details
                          </span>
                        </span>
                      </span>
                      <span v-else>
                        {{ props.formattedRow[props.column.field] }}
                      </span>
                    </template>
                  </vue-good-table>
                </center>
              </div>
              <div v-else>
                <center>
                  <i
                    style="font-size:35px;color:grey"
                    class="far fa-frown mb-3"
                    aria-hidden="true"
                  ></i>
                  <h4 class="font-bold">No search results found</h4>
                </center>
              </div>
            </div>
            <!-- .card-innr -->
          </div>
          <!-- .card -->
        </div>
        <div v-else class="container">
          <div class="content-area card">
            <div class="card-innr">
              <center class="card-body">
                <i
                  style="font-size:50px;color:grey"
                  class="far fa-frown pa-5"
                  aria-hidden="true"
                ></i>
                <h2 class="mt-5 font-bold">No data available to display</h2>
              </center>
            </div>
          </div>
        </div>
      </div>

      <div
        style="margin-top:5%;border:2px blue"
        v-else-if="userData.length <= 0 && dataFound == false"
        class="container"
      >
        <div class="row justify-content-center">
          <div
            style="border:0.9px solid blue;border-radius:10px;"
            class="card col-10 col-xs-12"
          >
            <div class="card-body">
              <center class="card-body">
                <i
                  style="font-size:250px;color:grey"
                  class="far fa-frown pa-5"
                  aria-hidden="true"
                ></i>
                <h2 class="mt-5 font-bold">No data available to display</h2>
              </center>
            </div>
          </div>
        </div>
      </div>

      <div data-backdrop="false" class="modal fade" id="myModal">
        <div class="modal-dialog">
          <div class="modal-content">
            <!-- Modal Header -->
            <div class="modal-header">
              <h4 class="modal-title font-weight-bold">Insufficient Balance</h4>
              <!-- <button @click="email=''" type="button" data-dismiss="modal" class="close">&times;</button> -->
            </div>

            <!-- Modal body -->
            <div class="modal-body">
              <h5>
                You don't have enough balance to make payment of 5000 trx,
                please keep minimum 5200 trx to avoid transaction failures
              </h5>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
              <center>
                <button
                  data-dismiss="modal"
                  type="button"
                  class="btn btn-primary"
                >
                  Close
                </button>
              </center>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="getAmount < 0.05 && isSpecial == false">
      <div style="margin-top:5%;border:2px blue" class="container">
        <div class="row justify-content-center">
          <div
            style="border:0.9px solid blue;border-radius:10px;"
            class="card col-10 col-xs-12"
          >
            <div class="card-body">
              <center class="card-body">
                <i
                  style="font-size:200px;color:grey"
                  class="far fa-smile pa-5"
                  aria-hidden="true"
                ></i>
                <h2 class="mt-3 font-bold">
                  You need to deposit 5000 TRX in order to access details of the
                  users in the near future
                </h2>

                <button
                  @click.prevent="depositAmount"
                  class="btn btn-primary mt-4"
                >
                  Click here to deposit
                </button>
              </center>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="isSpecial == true">
      <div v-if="userData.length > 0 && dataFound" class="page-content">
        <div style="text-align:center">
          <h2 class="headline mb-4">Approved User Details</h2>
        </div>

        <div
          style="margin-bottom:20px;"
          v-if="userData.length > 0"
          class="container"
        >
          <div
            class="p-1 card"
            style="border-radius:10px;border-left:#2C80FF 4px solid;border-right:#2C80FF 4px solid;"
          >
            <!-- <div style="padding:15px;border:1px black" class="input-group">
            <input
              type="search"
              v-model="name"
              style="border-right:0"
              placeholder="Search by Email address or Name"
              aria-describedby="button-addon1"
              class="form-control bg-light"
            >
            <div class="input-group-append">
              <button
                type="submit"
                style="border-radius:0px 3px 3px 0px;border-left:0px "
                class="border bg-light px-2 py-0 text-primary btn-link"
              >
                <em class="fa fa-search"></em>
              </button>
            </div>
          </div> -->

            <div class="">
              <div v-if="getUserData.length > 0">
                <center>
                  <vue-good-table
                  
                    :sort-options="{
                      enabled: false,
                    }"
                    :search-options="{
                      enabled: true,
                      externalQuery: search,
                      skipDiacritics: true,
                      searchFn: searchData,
                      placeholder:
                        'Search by Email address or name',
                    }"
                    style="width:auto;z-index:0;border-radius:10px;"
                    :columns="columns"
                    :rows="userData"
                    :pagination-options="{
                      enabled: true,
                      mode: 'records',
                      perPage: 5,
                      position: 'bottom',
                      perPageDropdown: [3, 7, 10,15,20],
                      dropdownAllowAll: false,
                      setCurrentPage: 1,
                      nextLabel: 'next',
                      prevLabel: 'prev',
                      rowsPerPageLabel: 'Rows per page',

                      pageLabel: 'page', // for 'pages' mode
                      allLabel: 'All',
                    }"
                  >
                    <template slot="table-row" slot-scope="props">
                      <span v-if="props.column.field == 'user'">
                        <p class="font-bold mb-0">{{ props.row.fullName }}</p>
                        <p style="font-size:13px;" class=" mb-0 mt-0 pt-0">
                          {{ props.row.email }}
                        </p>

                        <!-- <span
                        class="dt-status-sm badge badge-sq badge-outline badge-success badge-md"
                        >A</span
                      > -->
                      </span>
                      <span v-if="props.column.field == 'status'">
                        <span
                          class=" badge badge-outline badge-success badge-md"
                          >Approved</span
                        >
                        <!-- <span
                        class="dt-status-sm badge badge-sq badge-outline badge-success badge-md"
                        >A</span
                      > -->
                      </span>
                      <span v-if="props.column.field == 'viewDetails'">
                        <span
                          @click="
                            $router.push({
                              name: 'userData',
                              params: { userAddress: props.row.user },
                            })
                          "
                        >
                          <span
                            style="margin-left:0"
                            href="#"
                            class="btn btn-light-alt btn-xs btn-icon"
                          >
                            <em class="ti ti-eye"></em> View Details
                          </span>
                        </span>
                      </span>
                      <span v-else>
                        {{ props.formattedRow[props.column.field] }}
                      </span>
                    </template>
                  </vue-good-table>
                </center>
              </div>
              <div v-else>
                <center>
                  <i
                    style="font-size:35px;color:grey"
                    class="far fa-frown mb-3"
                    aria-hidden="true"
                  ></i>
                  <h4 class="font-bold">No search results found</h4>
                </center>
              </div>
            </div>
            <!-- .card-innr -->
          </div>
          <!-- .card -->
        </div>
        <div v-else class="container">
          <div class="content-area card">
            <div class="card-innr">
              <center class="card-body">
                <i
                  style="font-size:50px;color:grey"
                  class="far fa-frown pa-5"
                  aria-hidden="true"
                ></i>
                <h2 class="mt-5 font-bold">No data available to display</h2>
              </center>
            </div>
          </div>
        </div>
      </div>

      <div
        style="margin-top:5%;border:2px blue"
        v-else-if="userData.length <= 0 && dataFound == false"
        class="container"
      >
        <div class="row justify-content-center">
          <div
            style="border:0.9px solid blue;border-radius:10px;"
            class="card col-10 col-xs-12"
          >
            <div class="card-body">
              <center class="card-body">
                <i
                  style="font-size:250px;color:grey"
                  class="far fa-frown pa-5"
                  aria-hidden="true"
                ></i>
                <h2 class="mt-5 font-bold">No data available to display</h2>
              </center>
            </div>
          </div>
        </div>
      </div>

      <div data-backdrop="false" class="modal fade" id="myModal">
        <div class="modal-dialog">
          <div class="modal-content">
            <!-- Modal Header -->
            <div class="modal-header">
              <h4 class="modal-title font-weight-bold">Insufficient Balance</h4>
              <!-- <button @click="email=''" type="button" data-dismiss="modal" class="close">&times;</button> -->
            </div>

            <!-- Modal body -->
            <div class="modal-body">
              <h5>
                You don't have enough balance to make payment of 5000 TRX or more.
               
              </h5>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
              <center>
                <button
                  data-dismiss="modal"
                  type="button"
                  class="btn btn-primary"
                >
                  Close
                </button>
              </center>
            </div>
          </div>
        </div>
      </div>
    </div>

   <div data-backdrop="false" class="modal my-auto fade fade-enter" id="paymentModal">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Enter password to sign the transaction</h4>
            <button type="button" @click="pk='';password=''" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>

          <div class="modal-body">
             <div class="input-item input-with-label">
              <label class="input-item-label">
                Enter amount you want to deposit
                <span class="text-danger">*</span>
              </label>
              <input
                type="number"
                v-model="paymentAmount"
                class="input-bordered"
              />
            </div>


            <div class="input-item input-with-label">
              <label class="input-item-label">
                Password
                <span class="text-danger">*</span>
              </label>
              <input
                type="password"
                v-model="password"
                class="input-bordered"
              />
            </div>
          </div>

          <div class="modal-footer">
            <button
              @click="depositAmount"
              type="button"
              class="btn btn-success"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { decrypt } from "../utils/crypto";


export default {
  name: "KYCDetailsParty",
  data() {
    return {
      columns: [
        { label: "User", field: "user",tdClass:'text-center',thClass:'text-center',width:'auto' },
        { label: "Doc Type", field: "docType",tdClass:'text-center',thClass:'text-center' },
        { label: "Status", field: "status",tdClass:'text-center',thClass:'text-center' },
        { label: "View Details", field: "viewDetails",tdClass:'text-center',thClass:'text-center' },
      ],
      dataFound: undefined,
      paymentAmount:0,
      partyName: "",
      isSpecial: undefined,
      userData: [],
      pendingData: undefined,
      user: "",
      name: "",
      email1: "",
      email2: "",
      amount: undefined,
      pk: "",
      password: "",
      currentAddress: this.$cookies.get("address"),
      web3: this.$store.state.web3,
    };
  },
  asyncComputed: {
    async getUserData() {
      if (this.name !== "") {
        return this.userData.filter((data) => {
          data.email = data.email.toLowerCase();
          return (
            data.email.startsWith(this.name.toLowerCase()) ||
            data.fullName.toLowerCase().startsWith(this.name.toLowerCase())
          );
        });
      } else {
        return this.userData;
      }
    },

    async getAmount() {
      return this.$store.state.depositedAmount;
    },
    // return this.pendingData.filter(data =>
    //    data.Emails.some(email => email==this.email)
    // );
  },
  methods: {
    searchData(row, col, cellValue, searchTerm) {
      console.log(searchTerm);
      return (
        row.email.toLowerCase().startsWith(searchTerm.toLowerCase()) ||
        row.fullName.replace(/ /g,'').toLowerCase().startsWith(searchTerm.toLowerCase())
      );
    },
    async getLen() {
      try {
        let len = await this.$store.state.KYC.getPartyDetails().call();
        console.log(len);
        this.isSpecial = len.isSpecial;
        this.partyName = len.partyName;
        // if (len.arr.length > 0) {
        //   this.dataFound = true;
        // } else {
        //   this.dataFound = false;
        //   this.$store.state.loading = false;
        // }
      } catch (err) {
        console.log(err);
      }
    },

    // async getUpdatedDetails(address,email){
    //   let obj=undefined;
    //   let data=await this.$store.state.tronWeb.event.getEventsByContractAddress(
    //     this.$store.state.address,
    //     { eventName: "userUpdated",filters:{user:this.$store.state.tronWeb.address.toHex(address).replace('41','0x')},size:200}
    //   );
    //   if(data.length>0)
    //   {
    //     let arr=data[data.length-1];
    //      obj={
    //         fullName:await decrypt(ar.result.fullName),
    //         docType:await decrypt(arr.result.docType),
    //         userAddress:address,
    //         email:email
    //       }
    //   }

    //   return obj;

    // },

    async getDetails(userAddress, fullName, email, docType) {
      try {
       
        userAddress = this.$store.state.tronWeb.address.fromHex(userAddress);
        let blocked = await this.$store.state.KYC.blocked(userAddress).call();

        if (blocked == false) {
          let obj;

          obj = {
            fullName: fullName,
            docType: docType,
            
            userAddress: userAddress,
            email:email,
          };
          this.userData.push(obj);
         this.userData= this.userData.reverse();
        }
      } catch (err) {
        console.log(err);
      }
    },
    async checkStatus(id) {
      let vm = this;
      let timer = setInterval(async () => {
        let info = await vm.$store.state.tronWeb.trx.getTransactionInfo(id);
        console.log(info);
        if (info.receipt.result == "SUCCESS") {
           clearInterval(timer);
          this.$store.state.loading = false;
          console.log(info);
          this.$toasted.global.my_app_success({
            message: "Transaction completed",
          });
          await this.$store.dispatch("getDepositedAmount", this.currentAddress);
          await this.$store.dispatch("getCurrentBalance", this.curretAddress);
         
        } else if (info.result == "FAILED") {
           clearInterval(timer);
          this.$store.state.loading = false;
          console.log(info);
          this.$toasted.global.my_app_error({
            message: "Transaction failed",
          });
         
        }
      }, 1000);
    },

    async depositAmount() {
     
      try {
        await this.$store.dispatch("getCurrentBalance", this.currentAddress);
        if (this.$store.state.currentBalance < 5000) {
          window
            .$("#myModalWarn")
            .modal({ backdrop: "static", keyboard: false, show: true });
        }
       
        else {
          if(this.paymentAmount==0){
           
           window
            .$("#paymentModal")
            .modal({ backdrop: "static", keyboard: false, show: true })
          }
         else if(this.paymentAmount<5000)
          {

           this.$toasted.global.my_app_error({
            message: "You need to deposit minimum 5000 TRX",
          });
          }
         
            else if(this.password == "") {
            
           this.$toasted.global.my_app_error({
            message: "Please enter password",
          });
          } else if (this.password != "") {
            // this.$store.state.loading = true;
            try{
            await this.loginKeyStore();
           
          this.$store.state.loading = true;
          var options = {
            feeLimit: 20000000,
            callValue: this.$store.state.tronWeb.toSun(this.paymentAmount),
            // tokenValue:10,
            // tokenId:1000001
          };
          let params = [
            // { type: "address", value: this.name },
            // { type: "string", value: "Poland" },
            // { type: "string", value: "ironman5@gmail.com" },
          ];

          // await this.$store.state.tronWeb.setPrivateKey(
          //   "501AD9779D596A58E004BFDF51848FFF7D6E6C65D2CF914E149067FADA45162B"
          // );
          let tx = await this.$store.state.tronWeb.transactionBuilder.triggerSmartContract(
            this.$store.state.tronWeb.address.toHex(this.$store.state.address),
            "depositAmount()",
            options,
            params,
            this.$store.state.tronWeb.address.toHex(this.currentAddress)
          );
          console.log("transacion:", tx);
          // .then(res => {
          //   console.log(res)
          // })
          // .catch(err => {
          //   console.log(err)
          // })
          // async (err, transaction) => {
          //   if (err) return console.error(err)

          //   console.group('Unsigned trigger smart contract transaction')
          //   // console.log('- Contract Address: TA2x74755e7UZXGHWbw4CP1FZbEVvpFP9m')
          //   console.log(
          //     '- Transaction:\n' + JSON.stringify(transaction, null, 2),
          //     '\n'
          //   )
          //   console.groupEnd()
          // }

          const signedTransaction = await this.$store.state.tronWeb.trx.sign(
            tx.transaction,
            this.pk
          );
          console.group("Signed  transaction");
          // console.log(
          //   '- Transaction:\n' + JSON.stringify(signedTransaction, null, 2),
          //   '\n'
          // )
          console.groupEnd();

          await this.$store.state.tronWeb.trx.sendRawTransaction(
            signedTransaction,
            async (err, result) => {
              if (err) {
                console.error(err);
              }

              console.group("Broadcast transaction");
              console.log(
                "- Result:\n" + JSON.stringify(result, null, 2),
                "\n"
              );
              console.log(tx.transaction.txID);
              await this.checkStatus(tx.transaction.txID);
              //let interval=setInterval(this.checkStatus("abae87085c017dc7f6d0134288692c7232f7d03807cf6df9426541f59008d3b2"),5000);
              //  ("abae87085c017dc7f6d0134288692c7232f7d03807cf6df9426541f59008d3b2");

              console.groupEnd();
            }
            
          );
        
            }
            catch(err){
               this.pk=""
        this.password=""
        console.log(err);
            }
          
          }
        }
      } catch (err) {
        this.pk=""
        this.password=""
        console.log(err);
      } finally {
       
      }
    },

    async loginKeyStore() {
      if (localStorage.wallet) {
       
        try {
        
           this.$store.state.loading = true;
          let wallet=await decrypt(this.password,localStorage.wallet);
          console.log(wallet)
          //wallet=JSON.parse(wallet)
          this.pk=wallet.privateKey;
              window
              .$("#paymentModal")
              .modal("hide")
         
                
        } catch (err) {
          this.$store.state.loading = false;
          this.$toasted.global.my_app_error({
            message: "Please enter correct password",
          });
          throw err;
        }
      } 
      
      else {
        this.$toasted.global.my_app_error({
          message: "Wallet is not available",
        });
      }
    },

    openNotice(address) {
      this.user = address;
      window.$("#myModalNew").modal({ backdrop: "static", keyboard: false });
    },
    async fetchDetails() {
      let key = process.env.VUE_APP_API_KEY;

      try {
        let partyEvents = await axios({
          url:
            this.$store.state.eventUrl +
            "payments" +
            "?party=" +
            this.currentAddress,
          method: "get",

          headers: {
            Authorization: "Basic " + key,
          },
        });

        partyEvents = partyEvents.data.data.events;
        if(partyEvents.length==0){
           this.dataFound = false;
            this.$store.state.loading = false;
            return;
        }
        // partyEvents = partyEvents.reverse();
        for (let i = 0; i < partyEvents.length; i++) {
          this.$store.state.loading = true;
          this.dataFound = true;
          await this.getDetails(
            partyEvents[i].result.user,
            partyEvents[i].result.fullName,
            partyEvents[i].result.email,
            partyEvents[i].result.docType
          );

          this.$store.state.loading = false;
        }
      } catch (err) {
        console.log(err.response);
      }
    },
  },

  async created() {
    this.$store.state.loading = true;
    console.log("truuuuu")
    // await this.$store.dispatch('setContract');
    await this.$store.dispatch("getCurrentBalance", this.currentAddress);
    await this.$store.dispatch("getDepositedAmount", this.currentAddress);
    await this.getLen();
    console.log(this.currentAddress);
    console.log(this.$store.state.tronWeb.address.fromHex(this.currentAddress));
    await this.fetchDetails();
     this.$store.state.loading = false;
    
  },
};
</script>
<style scoped>
@import "../assets/css/style.css";
@import "../assets/css/vendor.bundle.css?ver=104";
@import "../assets/css/style.css?ver=104";
.custom-th-class{
  color:blue;
}
#myModal {
  position: absolute;
  top: 15%;

  bottom: 0;
  left: 0;
  z-index: 10040;
  overflow: auto;
  overflow-y: auto;
}

#myModalNew {
  top: 10%;

  bottom: 0;
  left: 0;
  z-index: 10040;
  overflow: auto;
  overflow-y: auto;
}
</style>
